import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { RegularAssessment } from "@/schema/console/regular-assessments/RegularAssessment";
import { Copy20Regular, DocumentAdd20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface CreateTestButtonProps {
  currentActiveTest?: RegularAssessment;
}

function CreateTestButton({ currentActiveTest }: CreateTestButtonProps) {
  const hasActiveTest = !!currentActiveTest;
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button>{t("create-new-test")}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onClick={() => {
            navigate("/console/regular-assessments/create");
          }}
        >
          <DocumentAdd20Regular className="mr-1" />
          <span>{t("start-from-scratch")}</span>
        </DropdownMenuItem>
        {hasActiveTest && (
          <DropdownMenuItem
            onClick={() => {
              navigate(`/console/regular-assessments/create?duplicate=true`);
            }}
          >
            <Copy20Regular className="mr-1" />
            <span>{t("duplicate-current-test")}</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateTestButton;
